export const fonts = {
  display: "'Space Grotesk', sans-serif",
  body: "'Manrope', sans-serif",
  mono: "'JetBrains Mono', monospace",
};

export const lightTheme = {
  name: 'light',
  bg: 'oklch(97% 0.012 95)',
  surface: '#ffffff',
  surfaceBorder: 'oklch(91% 0.01 95)',
  textPrimary: 'oklch(22% 0.02 260)',
  textMuted: 'oklch(45% 0.02 260)',

  topbarBg: 'oklch(24% 0.03 260)',
  topbarBgActive: 'oklch(33% 0.03 260)',
  topbarText: 'oklch(97% 0.01 95)',
  topbarTextMuted: 'oklch(72% 0.02 260)',

  sidebarBg: '#ffffff',
  sidebarBorder: 'oklch(91% 0.01 95)',
  sidebarActiveBg: 'oklch(93% 0.05 128)',
  sidebarText: 'oklch(22% 0.02 260)',

  accent: 'oklch(84% 0.19 128)',
  accentContrast: 'oklch(24% 0.03 260)',
  accentSoft: 'oklch(93% 0.08 128)',
  neutralSoft: 'oklch(93% 0.02 260)',
  cardShadow: '0 1px 2px rgba(20, 20, 30, 0.04), 0 8px 20px -12px rgba(20, 20, 30, 0.12)',

  positive: 'oklch(42% 0.13 150)',
  positiveBg: 'oklch(92% 0.06 150)',
  negative: 'oklch(58% 0.17 25)',
  pending: 'oklch(45% 0.12 70)',
  pendingBg: 'oklch(93% 0.09 80)',

  chartInflow: 'oklch(30% 0.03 260)',
  chartOutflow: 'oklch(62% 0.17 35)',
  chartLine: 'oklch(52% 0.14 128)',
  chartLineDot: 'oklch(78% 0.18 128)',
  chartGrid: 'oklch(91% 0.01 95)',

  categoryColors: ['oklch(58% 0.15 260)', 'oklch(62% 0.15 190)', 'oklch(62% 0.17 35)', 'oklch(60% 0.16 300)', 'oklch(70% 0.15 90)'],
};

export const darkTheme = {
  name: 'dark',
  bg: 'oklch(13% 0.016 260)',
  surface: 'oklch(23% 0.02 260)',
  surfaceBorder: 'oklch(34% 0.02 260)',
  textPrimary: 'oklch(95% 0.006 90)',
  textMuted: 'oklch(68% 0.02 260)',

  topbarBg: 'oklch(10% 0.016 260)',
  topbarBgActive: 'oklch(24% 0.02 260)',
  topbarText: 'oklch(96% 0.006 90)',
  topbarTextMuted: 'oklch(62% 0.02 260)',

  sidebarBg: 'oklch(19% 0.018 260)',
  sidebarBorder: 'oklch(30% 0.018 260)',
  sidebarActiveBg: 'oklch(28% 0.04 190)',
  sidebarText: 'oklch(95% 0.006 90)',

  accent: 'oklch(78% 0.15 190)',
  accentContrast: 'oklch(16% 0.018 260)',
  accentSoft: 'oklch(78% 0.15 190 / 0.18)',
  neutralSoft: 'oklch(32% 0.02 260)',
  cardShadow: '0 1px 2px rgba(0, 0, 0, 0.3), 0 10px 24px -12px rgba(0, 0, 0, 0.55)',

  positive: 'oklch(78% 0.15 190)',
  positiveBg: 'oklch(78% 0.15 190 / 0.16)',
  negative: 'oklch(65% 0.19 25)',
  pending: 'oklch(75% 0.13 80)',
  pendingBg: 'oklch(75% 0.13 80 / 0.16)',

  chartInflow: 'oklch(55% 0.02 260)',
  chartOutflow: 'oklch(60% 0.18 25)',
  chartLine: 'oklch(78% 0.15 190)',
  chartLineDot: 'oklch(78% 0.15 190)',
  chartGrid: 'oklch(28% 0.018 260)',

  categoryColors: ['oklch(70% 0.13 190)', 'oklch(70% 0.14 300)', 'oklch(65% 0.19 25)', 'oklch(75% 0.13 80)', 'oklch(72% 0.14 128)'],
};
